import React from 'react'

// brand
import { useBrand } from 'components/shared/SettingsProvider'
import BrandLogo from 'components/shared/BrandLogo'

const PlaceholderAvatar = () => {
  const { id } = useBrand()

  return <BrandLogo brand={id} sx={{ width: '60px' }} />
}

export default PlaceholderAvatar
